module.exports = __webpack_public_path__ + "media/images/android-chrome-192x192-c082a8e47a5d6c42cd06176215879af3.png";